// Single source of truth for the app's display version. Imported by src/main.js
// (shown in the bottom-right badge and the Sun panel), the build orchestrator
// (landing-page footer + build-info.json), and the headless verification
// scripts (scripts/optionstest.mjs, scripts/landingtest.mjs), so a release
// bump can't leave a test asserting a stale version. Native ESM: works in
// no-build, dev and build modes and under Node. Bump this on each release.
export const APP_VERSION = 'v0.6.0';
